export * from './ShortcutProperties'
